var _path, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFaucet(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 28,
    height: 29,
    viewBox: "0 0 28 29",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M25.0175 17.1826V12.8433C25.0175 10.5748 23.1962 8.73728 20.9601 8.73728H17.3499C17.2866 8.14825 16.7919 7.70021 16.1995 7.69538H14.7509V5.40418H16.4279C17.23 5.40418 17.8863 4.74144 17.8863 3.92964C17.8872 3.122 17.2355 2.46528 16.4279 2.45996H10.0291C9.22702 2.45996 8.57239 3.12269 8.57239 3.92964C8.57239 4.74144 9.22702 5.40417 10.0307 5.40417H11.7078V7.69538H10.2608C9.66718 7.69857 9.17059 8.14703 9.10711 8.73728H5.82424V5.18056C5.82693 4.92553 5.62236 4.7166 5.36733 4.71392C5.36624 4.71391 5.36515 4.7139 5.36406 4.7139H3.4423C3.18725 4.71388 2.98047 4.92063 2.98047 5.17568C2.98047 5.17731 2.98047 5.17894 2.98047 5.18056V18.56C2.98047 18.816 3.1879 19.0266 3.4423 19.0266H5.3592C5.6136 19.0266 5.821 18.816 5.821 18.56V15.0081H9.10549C9.17104 15.5946 9.66422 16.0398 10.2543 16.0451H16.1914C16.782 16.0386 17.2759 15.5947 17.3451 15.0081H18.8099V17.1826C18.8099 17.4403 19.0173 17.6493 19.2717 17.6493H24.5541C24.8085 17.6493 25.0159 17.4387 25.0159 17.1826H25.0175ZM21.9145 18.9699C21.6229 19.5727 20.1726 22.606 20.1726 23.6139C20.1726 24.813 21.14 25.7933 22.3293 25.7933C23.5187 25.7933 24.4828 24.813 24.4828 23.6139C24.4828 22.606 23.0358 19.5727 22.7442 18.9699C22.5918 18.6539 22.0766 18.6539 21.9145 18.9699Z",
    fill: "url(#paint0_linear_47537_77315)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_47537_77315",
    x1: 13.999,
    y1: 2.45996,
    x2: 13.999,
    y2: 39.2696,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFaucet);
export default __webpack_public_path__ + "static/media/Faucet.a189b389b0c9aeb98a3106758370fc79.svg";
export { ForwardRef as ReactComponent };